// modal-confirmation-sms.component.ts

import {
  Component,
  ElementRef,
  Inject,
  OnInit,
  ViewChild,
} from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";
import { InputOtpModule } from "primeng/inputotp";
import { interval, Subscription } from "rxjs";
import { AuthService } from "../../../app/services/auth.service";
import { SnackBarService } from "../../../app/services/snack-bar.service";
import { ButtonComponent } from "../button/button.component";
import { PageHeaderComponent } from "../page-header/page-header.component";

export interface ModalConfirmationData {
  userId?: number;
  userEmail?: string;
  required?: boolean;
}

@Component({
  selector: "app-modal-confirmation",
  imports: [
    ReactiveFormsModule,
    ButtonComponent,
    PageHeaderComponent,
    InputOtpModule,
    FormsModule,
    MatDialogModule,
  ],
  templateUrl: "./modal-confirmation.component.html",
  styleUrls: ["./modal-confirmation.component.scss"],
})
export class ModalConfirmationComponent implements OnInit {
  emailForm: FormGroup;
  codeForm: FormGroup;
  userId?: number;
  userEmail?: string;
  isCodeSent = false;
  isTimerActive = false;
  timer: number = 60;
  code?: string;
  private timerSubscription!: Subscription;
  @ViewChild("phoneNumberInput") phoneNumberInputElement!: ElementRef;
  @ViewChild("codeInput") codeInputElement!: ElementRef;

  constructor(
    public dialogRef: MatDialogRef<ModalConfirmationComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ModalConfirmationData | null,
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private snackbarService: SnackBarService,
  ) {
    // Set properties from data if provided
    if (data) {
      this.userId = data.userId;
      this.userEmail = data.userEmail;
    }

    this.emailForm = this.formBuilder.group({
      email: ["", [Validators.required, Validators.email]],
    });

    this.codeForm = this.formBuilder.group({
      code: ["", [Validators.required]],
    });
  }

  ngOnInit() {
    if (this.userEmail) {
      this.emailForm.controls["email"].setValue(this.userEmail);
    }
  }

  onSendCode() {
    if (this.emailForm.invalid) {
      this.snackbarService.openSnackBar(
        "Por favor, insira um email válido.",
        "Fechar",
        "error",
      );

      return;
    }

    const email = this.emailForm.value.email;
    const dataBody = {
      user: {
        email: email,
      },
    };

    this.authService.requestConfirmationCode(dataBody).subscribe(() => {
      this.snackbarService.openSnackBar(
        "Código enviado com sucesso!",
        "Fechar",
        "success",
      );
      this.isCodeSent = true;
      setTimeout(() => this.codeInputElement.nativeElement.focus(), 0);
      this.startTimer();
    });
  }

  closeModalSuccess() {
    this.snackbarService.openSnackBar(
      "Código verificado com sucesso! Você já pode fazer o login.",
      "Fechar",
      "success",
    );
    this.dialogRef.close(true);
  }

  onVerifyCode() {
    if (!this.code || this.code.length !== 6) {
      // if (this.codeForm.invalid) {
      this.snackbarService.openSnackBar(
        "Por favor, insira o código.",
        "Fechar",
        "error",
      );
      return;
    }

    // const code = this.codeForm.value.code;
    const code = this.code;

    this.authService.accountConfirmation(code).subscribe({
      next: (response) => {
        console.log("RESPONSE code", response);
        this.closeModalSuccess();
      },
      error: (error) => {
        if (error.status == 200) {
          this.closeModalSuccess();
          return;
        }
      },
    });
  }

  startTimer() {
    this.isTimerActive = true;
    this.timer = 60;
    this.timerSubscription = interval(1000).subscribe(() => {
      this.timer--;
      if (this.timer === 0) {
        this.stopTimer();
      }
    });
  }

  cancelSentCode() {
    this.isCodeSent = false;
  }

  stopTimer() {
    this.isTimerActive = false;
    if (this.timerSubscription) {
      this.timerSubscription.unsubscribe();
    }
  }
}
